import React from 'react';
import { FormGroup, Col, ButtonToolbar } from 'react-bootstrap';

const FormActions = ({ horizontal, children }) => {
	const buttons = <ButtonToolbar>{children}</ButtonToolbar>;

	if (horizontal) {
		return (
			<FormGroup>
				<Col smOffset={2} sm={10}>
					{buttons}
				</Col>
			</FormGroup>
		);
	}

	return buttons;
};

export default FormActions;